import { StateAction } from '../state-action.interface';

export const userModeActionTypes = {
    SET_USER_MODE: 'SET_USER_MODE'
}

export function userModeReducer(state: string = 'default', action: StateAction): string {
    switch(action.type) {
        case userModeActionTypes.SET_USER_MODE: {
            return action.payload;
        }
        default:
            return state;
    }
}